import React from 'react';
import { MediaListTitle } from '../MediaListTitle/MediaListTitle';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const SwimlaneTitle = ({
  title,
  description,
  actionButton,
  titleLink
}) => /*#__PURE__*/_jsx(PlayContainer, {
  children: /*#__PURE__*/_jsx(MediaListTitle, {
    title: title,
    actionButton: actionButton,
    description: description,
    titleLink: titleLink
  })
});
export const getDeleteAllAction = (t, itemCount, onAction) => {
  const showDeleteAllAction = itemCount > 3;
  return showDeleteAllAction ? {
    text: t('global.deleteAll'),
    onAction
  } : undefined;
};